export default "__VITE_ASSET__CDqNZ$Xu__"